import * as React from 'react';
import useEffect from './use_effect';
import 'intersection-observer';
export default function useIntersectionObserver(elementRef) {
  var [entry, setEntry] = React.useState({
    isIntersecting: false
  });
  useEffect(() => {
    var didUnsubscribe = false;
    var observer;
    var element = elementRef.current;
    var callback = entries => {
      if (didUnsubscribe) return;
      var latestEntry = entries[entries.length - 1];
      setEntry(latestEntry);
    };
    if (element) {
      observer = new IntersectionObserver(callback);
      observer.observe(element);
    }
    return () => {
      if (element && observer) {
        didUnsubscribe = true;
        observer.unobserve(element);
      }
    };
  }, [elementRef]);
  return entry;
}